import theme from '../Theme';

const styles = () => ({
  inputColors: {
    backgroundColor: theme.colors.dark11,
  },
  buildingAddressWidth: {
    width: '50%',
    [theme.screenSize.middleWidth]: {
      width: '100%',
    },
  },
});

export default styles;
